import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Feature, FeatureSchema } from '@app/core/models/feature';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  features!: Feature;
  private http = inject(HttpClient);

  load() {
    const env = environment.environmentName;
    return this.http.get<Feature>(`/assets/features/${env}.json`).pipe(
      map((featuresData) => {
        const result = FeatureSchema.safeParse(featuresData);
        if (!result.success) {
          console.error('JSOn does not match schema', result.error);
        }
        return featuresData;
      }),
      tap((features) => {
        this.features = features;
      }),
    );
  }
}
